<template>
  <div class="enviar-mensagem-container">
    <v-container class="fill-height">
      <v-row class="fill-height" align="center" justify="center">
        <v-col cols="12" sm="10" md="8" lg="6">
          <v-card elevation="2" rounded="lg" class="pa-6">
            <div class="card-header gradient">
              <span class="header-title">Envie uma homenagem</span>
            </div>

            <v-form ref="form" v-model="valid" @submit.prevent="validarEnvio">
              <v-text-field
                v-model="publicacao.nomeCliente"
                label="Escreva seu nome *"
                :rules="[rules.required, rules.nome]"
                outlined
                color="#3d768a"
                maxlength="22"
                density="compact"
                hide-details="auto"
                class="mb-3"
              ></v-text-field>

              <v-text-field
                v-model="publicacao.telefone"
                label="Escreva o número do seu celular com DDD *"
                :rules="[rules.required, rules.telefone]"
                outlined
                color="#3d768a"
                density="compact"
                hide-details="auto"
                class="mb-3"
                v-mask="'(##) #####-####'"
              ></v-text-field>

              <v-text-field
                v-model="publicacao.email"
                label="Escreva o seu e-mail"
                :rules="[rules.email]"
                outlined
                color="#3d768a"
                density="compact"
                hide-details="auto"
                class="mb-3"
              ></v-text-field>

              <v-text-field
                v-model="publicacao.nomeHomenageado"
                label="Nome do Falecido"
                outlined
                color="#3d768a"
                maxlength="22"
                density="compact"
                hide-details="auto"
                class="mb-3"
              ></v-text-field>

              <v-textarea
                v-model="publicacao.mensagem"
                label="O que você gostaria de dizer? *"
                :rules="[rules.required, rules.mensagem]"
                outlined
                color="#3d768a"
                counter="145"
                maxlength="145"
                rows="4"
                hide-details="auto"
                class="mb-3"
              ></v-textarea>

              <div class="d-flex justify-space-between align-center mt-4">
                <v-spacer></v-spacer>

                <v-btn
                  :loading="loading"
                  :disabled="!valid || loading"
                  style="
                    background: linear-gradient(135deg, #3d768a, #74b3d4);
                    color: white;
                  "
                  type="submit"
                >
                  <v-icon class="mr-2" left>mdi-send</v-icon>
                  Enviar Mensagem
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
  <Footer />
</template>

<script>
import { useToast } from "vue-toastification";
import { http } from "@/services/config";
import authHeader from "@/services/auth-header";
import Footer from "@/components/restrito/Footer.vue";

export default {
  name: "EnviarMensagemPainel",
  components: { Footer },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      valid: false,
      loading: false,
      publicacao: {
        nomeCliente: "",
        nomeHomenageado: "",
        email: "",
        telefone: "",
        mensagem: "",
        titulo: "PainelFinados",
        nomeEmpresa: "Memorial Parque Maceió",
        nomeEvento: "Finados2026"
      },
      rules: {
        required: (v) => !!v || "Este campo é obrigatório",
        nome: (v) =>
          (v && v.length >= 3) || "O nome deve ter pelo menos 3 caracteres",
        email: (v) => {
          if (!v) return true; // Se estiver vazio, retorna válido
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || "Por favor, insira um e-mail válido";
        },
        telefone: (v) => {
          const numeroLimpo = v.replace(/\D/g, "");
          return (
            numeroLimpo.length === 11 ||
            "O telefone deve ter 11 dígitos (DDD + número)"
          );
        },
        mensagem: (v) =>
          (v && v.length >= 10) ||
          "A mensagem deve ter pelo menos 10 caracteres",
      },
    };
  },
  methods: {
    validarEnvio() {
      if (!this.$refs.form.validate()) return;

      http
        .post("homenagem/evento", this.publicacao, {
          headers: authHeader()
        })
        .then(() => {
          this.toast.success("Mensagem enviada com sucesso!");
          this.$refs.form.reset();
        })
        .catch((error) => {
          console.error("Erro ao enviar mensagem:", error);
          this.toast.error("Erro ao enviar mensagem");
        });
    },
  },
};
</script>

<style scoped>
.enviar-mensagem-container {
  min-height: 100vh;
  background-color: #faf9f5;
}

.card-header {
  padding: 16px;
  border-radius: 8px;
  margin: -24px -24px 24px -24px;
}

.header-title {
  color: white;
  font-size: 1.5em;
  font-weight: 500;
}

.gradient {
   background: linear-gradient(135deg, #3d768a, #74b3d4);

}

.v-btn {
  text-transform: none;
  font-weight: 500;
}
</style>
